// import

import type {GetStaticPaths, GetStaticProps} from 'next';
import * as R from 'ramda';

import {revalidate} from 'libs/constants';
import db from 'libs/db';
import type {PageNode} from 'libs/model';
import {PagePage} from 'modules/Page';

// types

type Props = {
  page: PageNode;
};

type Query = {
  slug: string[];
};

// component

export default function PageView(props: Props) {
  const {page} = props;

  return (
    <PagePage page={page} />
  );
}

// data

export const getStaticPaths: GetStaticPaths<Query> =
  async () => {
    return {
      fallback: 'blocking',
      paths: (await db.readPages())
        .filter(R.pathSatisfies(R.complement(R.isNil), ['meta', 'layout']))
        .map(({meta: {slug}}) => ({params: {slug: slug.split('/')}})),
    };
  };

export const getStaticProps: GetStaticProps<Props, Query> =
  async ({preview, params}) => {
    const [page] = await Promise.all([
      db.readPage(params?.slug.join('/') as string, {preview}),
    ]);

    if (!page) {
      return {notFound: true};
    }

    return {
      revalidate,
      props: {page},
    };
  };
